import React, { useState, useEffect, useContext } from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import "./LoginPage.css";
import loginLogo from "../../assets/loginLogo.png";
import topLeftIcon from "../../assets/topLeft.png";
import bottomLeftIcon from "../../assets/bottomLeft.png";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import emailIcon from "../../assets/emailIcon.png";
import passwordIcon from "../../assets/passwordIcon.png";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
import nextIcon from "../../assets/nextIcon.png";
import forgetPassword from "../../assets/forgetPassword.png";
import topRightIcon from "../../assets/topRight.png";
import bottomRightIcon from "../../assets/bottomRight.png";
import isValidEmail from "../../utils";
import action from "./action";
import { AppContext } from "../../context/crmContext";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { useNavigate } from "react-router-dom";

const LoginPage = () => {
  const [isNext, setIsNext] = useState(false);
  const [isUserNameValid, setIsUserNameValid] = useState(true);
  const { getLoginAuth, getAllEducations } = action;
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [accessToken, setAccessToken] = useState("");
  const [userDetails, setUserDetails] = useState({});
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [contextValues, setContextValues] = useState({});
  const [selectedSegment, setSelectedSegment] = useState("");
  const navigate = useNavigate();
  const context = useContext(AppContext);

  useEffect(() => {
    localStorage.removeItem("accessToken");
    if (localStorage.getItem("accessToken")) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
  }, []);

  const verifyLoginDetails = () => {
    if (selectedSegment.length) {
      navigate("/dashboard");
      return;
    }
    if (userName.length && password.length) {
      const payload = {
        email: userName,
        password: password,
      };
      getLoginAuth(payload, getAuthDetails, getLoginError);
    }
  };

  const getLoginError = (response) => {
    context.setSnackBarState({
      isOpen: true,
      message: response?.data?.message,
      statusCode: response?.data?.statusCode,
    });
  };

  const getAuthDetails = (data) => {
    if (data?.statusCode === 200) {
      setAccessToken(() => data?.result?.access_token);
      setIsNext(() => true);
      setUserDetails(() => data?.result?.userDetails);
      context.setUser(data?.result?.userDetails);
      setIsLoggedIn(() => true);
      const values = {
        accessToken: accessToken,
        userDetails: userDetails,
        isLoggedIn: isLoggedIn,
      };
      setContextValues(() => values);
      localStorage.setItem("accessToken", data?.result?.access_token);
    } else {
      localStorage.removeItem("accessToken");
    }
    context.setSnackBarState({
      isOpen: true,
      message: data?.message,
      statusCode: data?.statusCode,
    });
  };

  const getUserName = (value) => {
    const isValid = isValidEmail(value);
    setIsUserNameValid(() => isValid);
    if (isValid) {
      setUserName(() => value);
    } else {
      setUserName(() => "");
    }
  };

  const getPassword = (value) => {
    setPassword(() => value);
  };
  const handleSegment = (event) => {
    localStorage.setItem("userRole", event.target.value);
    const filteredRole = userDetails?.roles?.filter(
      (e) => e.name === event.target.value
    );
    localStorage.setItem("roleid", filteredRole[0].id);
    setSelectedSegment(() => event.target.value);
  };

  const passwordResetPage = () => {
    navigate("/reset-password")
  }

  return (
    // <AppContext.Provider
    //   value={{
    //     accessToken: accessToken,
    //     userDetails: userDetails,
    //     isLoggedIn: isLoggedIn,
    //   }}
    // >
    <div>
      <Container maxWidth="100%" style={{ padding: "0px" }}>
        <img className="top-left-image" src={topLeftIcon} />
        <img className="bottom-left-image" src={bottomLeftIcon} />
        <img className="top-right-image" src={topRightIcon} />
        <img className="bototm-right-image" src={bottomRightIcon} />
        <Box sx={{ bgcolor: "#3166a6", height: "50vh" }} />
        <Box sx={{ bgcolor: "#e4f8ff", height: "50vh" }} />
        <Box className={!isNext ? "login-area" : "login-area-1"}>
          <img src={loginLogo} width="100%" />
          <hr className="logo-divider"></hr>
          {!isNext ? (
            <>
              <InputLabel
                style={{ marginLeft: "7px", marginTop: "2vh" }}
                htmlFor="input-with-icon-adornment"
              >
                Username
              </InputLabel>
              <FormControl variant="standard" sx={{ m: 1 }}>
                <TextField
                  error={!isUserNameValid}
                  className="login-input"
                  id="outlined-start-adornment"
                  sx={{ width: "46ch" }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <img height="24px" width="24px" src={emailIcon} />
                      </InputAdornment>
                    ),
                  }}
                  onChange={(e) => getUserName(e.target.value)}
                />
              </FormControl>
              <InputLabel
                style={{ marginLeft: "7px" }}
                htmlFor="input-with-icon-adornment"
              >
                Password
              </InputLabel>
              <FormControl variant="standard" sx={{ m: 1 }}>
                <TextField
                  type="password"
                  className="login-input"
                  id="outlined-start-adornment"
                  sx={{ width: "46ch" }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <img height="24px" width="24px" src={passwordIcon} />
                      </InputAdornment>
                    ),
                  }}
                  onChange={(e) => getPassword(e.target.value)}
                />
              </FormControl>
              <FormGroup style={{ marginTop: "1vh", marginLeft: "1vh" }}>
                <FormControlLabel
                  className="checkbox-remember-password"
                  control={<Checkbox />}
                  label="Remember this password"
                />
              </FormGroup>
            </>
          ) : (
            <>
              <InputLabel
                style={{ marginLeft: "7px", marginTop: "5vh" }}
                htmlFor="input-with-icon-adornment"
              >
                Segment
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                //   value={age}
                sx={{ width: "50ch" }}
                label="Age"
                onChange={handleSegment}
              >
                {userDetails?.roles?.map((e) => (
                  <MenuItem value={e?.name}>{e?.name}</MenuItem>
                ))}
              </Select>
            </>
          )}
          <Button
            className="send-button"
            style={{
              width: "98%",
              marginTop: "2vh",
              marginBottom: "3vh",
              background: "#ff867a",
              justifyContent: "space-between",
              height: "52px",
              marginLeft: "1vh",
            }}
            variant="contained"
            endIcon={<img src={nextIcon} height="16px" width="16px" />}
            onClick={() => verifyLoginDetails()}
          >
            Next
          </Button>
          <div className="forget-password" onClick={() => passwordResetPage()}>
            <img src={forgetPassword} height="18px" width="18px" />
            <p style={{ marginTop: "0px", marginLeft: "10px" }}>
              Forgot Username & Password
            </p>
          </div>
        </Box>
      </Container>
    </div>
    // </AppContext.Provider>
  );
};

export default LoginPage;
